export default __webpack_public_path__ + "static/media/buergerbeteiligung.cc6c4155.svg";